<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Transaction Type Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :custom-filter="customSearch"
                :no-data-text="noDataText"
                item-key="key"
                show-select
                v-bind:search="search"
                v-model="selected"
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', 'tranType')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', 'tranType')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
export default {
  props: {
    tranType: String
  },
  data() {
    return {
      headers: [
        { text: 'tranType', value: 'tranType' },
        { text: 'Description', value: 'tranTypeDesc' }
      ],
      selected: [],
      tranTypes: [],
      items: [
        {
          key: 'N',
          tranType: 'N',
          tranTypeDesc: 'New'
        },
        {
          key: 'E',
          tranType: 'E',
          tranTypeDesc: 'Endorsed'
        },
        {
          key: 'C',
          tranType: 'C',
          tranTypeDesc: 'Cancelled'
        },
        {
          key: 'R',
          tranType: 'R',
          tranTypeDesc: 'Renewed'
        },
        {
          key: 'T',
          tranType: 'T',
          tranTypeDesc: 'Transferred'
        }
      ]
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>

<style>
</style>
